import * as React from 'react';
import { NavigationChorinitia } from '../Navigation/NavigationChorinitia';
import { ProtectedPage } from './ProtectedPage/ProtectedPage';
import { UserRole } from '../../../types/UserRole';

interface Props {
    allowedUsers: UserRole[];
    children: JSX.Element;
}

interface State {
}

export class PageChorinitia extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <div style={{ height: '100%' }}>
                <NavigationChorinitia />
                <div
                    className="col-12"
                    style={
                        {
                            backgroundAttachment: 'fixed',
                            background: '#1C1D26',
                            display: 'table',
                            height: 'calc(100% - 106px)',
                            paddingTop: '20px',
                            paddingBottom: '20px'
                        }
                    }
                >
                    <div
                        className="col-10 offset-1"
                        style={
                            {
                                backgroundColor: 'white',
                                height: '100%'
                            }
                        }
                    >

                        <ProtectedPage allowedUsers={this.props.allowedUsers} children={this.props.children} />
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/Page/PageChorinitia.tsx